<template>
  <s-wrapper :variant="avatarVariant" :size="avatarSize">
    <s-photo v-if="src">
      <img :src="src" />
    </s-photo>
    <slot v-else />
  </s-wrapper>
</template>

<script>
import { AppAvatarProps, SWrapper, SPhoto } from "./styles";

export default {
  name: "AppAvatar",
  components: {
    SWrapper,
    SPhoto
  },
  props: {
    ...AppAvatarProps,
    src: {
      type: String,
      default: ""
    }
  },
  computed: {
    avatarVariant() {
      const variants = ["primary", "light"];
      const variant = variants.includes(this.variant)
        ? this.variant
        : "primary";
      return variant;
    },
    avatarSize() {
      const sizes = ["sm", "md", "lg", "xl"];
      const size = sizes.includes(this.size) ? this.size : "md";
      return size;
    }
  }
};
</script>
